const prepareFinalPartnerFormData = (stepDataAll) => {
  const data = stepDataAll;
  const formData = new FormData();

  const s0 = data[0];
  const s1 = data[1];
  const s2 = data[2];
  const s3 = data[3];
  const s4 = data[4];

  formData.append("companyDocument", s0.companyDocument);
  formData.append("companyLegalName", s0.companyLegalName);
  formData.append("companyTradingName", s0.companyFantasyName || '');
  formData.append("companyEmail", s0.companyEmail || '');
  formData.append("companyPhone", s0.companyPhone || '');
  formData.append("companyState", s0.companyState || '');
  formData.append("companyCity", s0.companyCity || '');
  formData.append("companyMetadata", JSON.stringify(s0.companyDocumentMeta));
  formData.append("companyPersonDocument", s0.companyPersonDocument);
  formData.append("companyPersonName", s0.companyPersonName);
  formData.append("companyPersonBirthdate", s0.companyPersonBirthDay);
  formData.append("companyPersonGender", s0.companyPersonGender);
  formData.append("companyPersonMetadata", JSON.stringify(s0.companyPersonDocumentMeta));
  formData.append("companyPersonUserEmail", s0.personUserEmail);
  formData.append("companyPersonUserMobilePhone", s0.personUserPhone);
  formData.append("companyPersonUserPassword", s0.personUserPassword);

  formData.append("companyWppPhone", s1.companyWppPhone);
  formData.append("companyMainEmail", s1.companyMainEmail);
  formData.append("companyType", s1.companyBusinessType);
  formData.append("companyBusinessDescription", s1.companyDescription || '');

  if (Array.isArray(s1.servicesOffered)) {
    formData.append("companyServices", JSON.stringify(s1.servicesOffered));
    const leads = s1.servicesOffered.map(serviceId => {
      const item = s1.servicesOfferedFull?.find(x => x.id === serviceId);
      return {
        serviceId,
        servicePriceOf: item?.lead?.[0]?.servicePriceOf || '',
        servicePriceFor: item?.lead?.[0]?.servicePriceFor || '',
        perLeadPrice: item?.lead?.[0]?.perLeadPrice || 0,
        leadMinQuantity: s4.redirections?.[serviceId] || 0,
        leadMaxQuantity: s4.redirections?.[serviceId] || 0,
        discountPercentage: item?.lead?.[0]?.discountPercentage || 0,
      };
    });
    formData.append("companyServiceLeads", JSON.stringify(leads));
  }

  if (Array.isArray(s1.discountsOffered)) {
    formData.append("companyDiscountCoupons", JSON.stringify(s1.discountsOffered));
    const leads = s1.discountsOffered.map(discountCouponId => {
      const item = s1.discountsOfferedFull?.find(x => x.id === discountCouponId);
      return {
        discountCouponId,
        servicePriceOf: item?.lead?.[0]?.servicePriceOf || '',
        servicePriceFor: item?.lead?.[0]?.servicePriceFor || '',
        perLeadPrice: item?.lead?.[0]?.perLeadPrice || 0,
        leadMinQuantity: s4.redirections?.[discountCouponId] || 0,
        leadMaxQuantity: s4.redirections?.[discountCouponId] || 0,
        discountPercentage: item?.lead?.[0]?.discountPercentage || 0,
      };
    });
    formData.append("companyDiscountCouponLeads", JSON.stringify(leads));
  }  

  if (s2) {
    formData.append("companyAddress", JSON.stringify({
      label: "Endereço Principal",
      streetName: s2.address,
      streetNumber: s2.number || '',
      streetComplement: s2.complement || '',
      suburb: s2.neighborhood || '',
      city: s2.city || '',
      state: s2.uf || '',
      country: 'BR',
      postalCode: s2.cep?.replace(/\D/g, '') || '',
      fullAddress: s2.address,
      googleCoordinates: (s2.latitude && s2.longitude) ? `${s2.latitude},${s2.longitude}` : null,
      latitude: s2.latitude || null,
      longitude: s2.longitude || null,
      hasCoordinates: s2.hasCoordinates || false,
      googlePlaceId: s2.addressObj?.place_id || '',
    }));
  }

  formData.append("companyTecnicalResponsible", JSON.stringify({
    name: s1.technicalResponsibleName || '',
    document: s1.technicalResponsibleNumber || '',
    type: s1.companyBusinessType === 'oticas' ? 'optical' : 'clinic',
    uf: s1.technicalResponsibleUf || ''
  }));

  if (Array.isArray(s1.serviceCategories)) {
    formData.append("companySpeciality", JSON.stringify(
      s1.serviceCategories.map(catId => ({
        type: 'parent',
        SystemRepoCompanySpecialityId: catId
      }))
    ));
  }

  if (s3?.socialLinks?.length) {
    formData.append("companySocialMedia", JSON.stringify(
      s3.socialLinks.map(link => ({
        name: link.type,
        key: link.type,
        value: link.link
      }))
    ));
  }

  if (s3?.additionalPhones?.length) {
    formData.append("companyExtraPhones", JSON.stringify(
      s3.additionalPhones.map(p => ({
        value: p,
        type: 'fixed'
      }))
    ));
  }

  if (s3?.additionalEmails?.length) {
    formData.append("companyExtraEmail", JSON.stringify(
      s3.additionalEmails.map(e => ({
        value: e
      }))
    ));
  }

  if (s3.logoFile instanceof File) {
    formData.append("companyLogotype", s3.logoFile);
  }

if (s1.sendDocumentsLater) {
  formData.append("companyComprobationFilesSkip", "1");
} else {
  formData.append("companyComprobationFilesSkip", "0");

  if (s1.companyDocuments) {
    for (let docType in s1.companyDocuments) {
      const fileList = s1.companyDocuments[docType];

      if (Array.isArray(fileList)) {
        fileList.forEach((fileObj) => {
          const file = fileObj?.file instanceof File ? fileObj.file : fileObj;

          if (file instanceof File) {
            // ⚠️ Monta um objeto metadata com o tipo do documento
            const metadata = JSON.stringify({
              documentType: docType,
              documentName: file.name
            });

            // ⬇️ Apêndice no formato necessário para o backend
            formData.append("companyComprobationFiles", file, file.name);
            formData.append("companyComprobationFilesMetadata", metadata);
          }
        });
      }
    }
  }
}

  formData.append("companyBillingDocument", JSON.stringify({
    type: 'cnpj',
    value: s4.billingDocument
  }));

  if (!s4.creditCardLater && s4.cardToken) {
    formData.append("companyMainCreditCardSkip", "0");
    formData.append("companyMainCreditCard", JSON.stringify({
      cardToken: s4.cardToken,
      brand: s4.cardBrand,
      holderName: s4.cardHolderName,
      cpf: s4.cardHolderCpf
    }));
  } else {
    formData.append("companyMainCreditCardSkip", "1");
  }

  if (!s4.billingAddressSameAsBusiness && s4.billingAddress?.streetName) {
    formData.append("companyBillingAddress", JSON.stringify(s4.billingAddress));
  }

  // add billingAddressSameAsBusiness flag
  formData.append("billingAddressSameAsBusiness", s4.billingAddressSameAsBusiness ? "1" : "0");

  formData.append("companyWebsite", s3.website || '');

  return formData;
};

export default prepareFinalPartnerFormData;
